import { GroupSelect, Button } from 'app/components';
import { useTranslation } from 'react-i18next';
import styles from './Fleet.module.scss';

interface FleetManagmentI {
  handleAdd?: () => void;
  handleDelete?: () => void;
  handleExport?: () => void;
  handleImport?: () => void;
  handleEditGroups?: () => void;
  handleGroupChange?: (groupKey: string) => void;
  handleDeleteGroup?: () => void;
  disabled: boolean;
}
export const FleetManagementPanel = ({
  handleAdd,
  handleDelete,
  handleExport,
  handleImport,
  handleEditGroups,
  handleGroupChange,
  handleDeleteGroup,
  disabled = false,
}: FleetManagmentI) => {
  const { t } = useTranslation();

  return (
    <div className={styles.panel}>
      <Button label={t('ButtonLabelAddVessel')} variant="general" onClick={handleAdd} />
      <Button label={t('ButtonLabelDelete')} variant="general" onClick={handleDelete} disabled={disabled} />
      <Button label={t('ButtonLabelImportSCV')} variant="general" onClick={handleImport} />
      <Button label={t('ButtonLabelExportSCV')} variant="general" onClick={handleExport} disabled={!handleExport} />
      <GroupSelect onChange={handleGroupChange} onDeleteGroup={handleDeleteGroup} />

      <Button label={t('Groups')} variant="general" onClick={handleEditGroups} />
    </div>
  );
};
